import React, { FC, useEffect, useState } from "react";
import { displayRegistry } from "kw/util/DisplayRegistry";
import { getQuestionSetAnswers } from "kw/util/getQuestionSetAnswers";
import { isNullish } from "kanopi-components/utils/primitives";
import { StringDisplay } from "kw/util/DisplayRegistry/StringDisplay";
import { SummaryTable } from "./SummaryTable";
import { UnansweredDisplay } from "kw/util/DisplayRegistry/UnansweredDisplay";
import { useStyletron } from "kanopi-components/theme/useStyletron";

type TAdminRiskStateSection = {
  riskProfile: TRiskProfile;
  questionSets: TQuestionSet[];
  referredQuestionSetKeys?: string[];
  highlightReferred?: boolean;
  hasLongLabels?: boolean;
  additionalData?: unknown[];
};
export const AdminRiskStateSection: FC<TAdminRiskStateSection> = ({
  riskProfile,
  questionSets = [],
  referredQuestionSetKeys = [],
  highlightReferred = false,
  additionalData = [],
  hasLongLabels = false,
}) => {
  const [riskData, setRiskData] = useState<unknown>();
  const [, theme] = useStyletron();

  const labelStyles = hasLongLabels
    ? {
        maxWidth: "70%",
      }
    : { whiteSpace: "nowrap" };
  const valueStyles = hasLongLabels
    ? {}
    : {
        width: "100%",
      };
  const columnSchema = [
    {
      header: "",
      id: "id",
      children: (row) => row?.question?.displayLabel ? row?.question?.displayLabel : row?.question?.label,
      sortable: false,
      overrides: {
        TableBodyCell: {
          style: ({ $row }) => ({
            ...labelStyles,
            color: $row?.highlight
              ? theme.colors.negative
              : theme.colors.contentPrimary,
            ...theme.typography.LabelSmall,
            paddingLeft: 0,
          }),
        },
      },
    },
    {
      header: "",
      id: "id",
      children: (row) => {
        const DisplayComponent = isNullish(row.answer)
          ? UnansweredDisplay
          : displayRegistry.getByType(row.question?.inputType, StringDisplay);

        return (
          <DisplayComponent
            color={row?.highlight ? theme.colors.negative : "initial"}
            question={row?.question}
            answer={row?.answer}
          />
        );
      },
      sortable: false,
      overrides: {
        TableBodyCell: {
          style: ({ $row }) => ({
            ...valueStyles,
            color: $row?.highlight
              ? theme.colors.negative
              : theme.colors.contentPrimary,
          }),
        },
      },
    },
  ];
  useEffect(() => {
    if (riskProfile?.riskData) {
      const _riskData = additionalData || [];
      questionSets?.map((questionSet) => {
        const answers = getQuestionSetAnswers(questionSet, riskProfile?.riskData);
        const highlight =
          highlightReferred && referredQuestionSetKeys.includes(questionSet?.key);

        const questions = questionSet?.questions || [];
        questions.map((question) => {
          const answer = answers[question?.id];
          _riskData.push({
            id: question?.id,
            question: question,
            answer: answer,
            highlight: highlight,
          });
        });
      });
      setRiskData(_riskData);
    }
  }, []);

  return (
    <>
      <SummaryTable
        columnSchema={columnSchema}
        data={riskData}
        showPagination={false}
        showSearchSection={false}
        loading={false}
        type="RISK_STATE"
        emptyMessage="No details were provided."
      />
    </>
  );
};
